import { render, staticRenderFns } from "./PromotionalTagNew.vue?vue&type=template&id=02367124&"
import script from "./PromotionalTagNew.vue?vue&type=script&lang=js&"
export * from "./PromotionalTagNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports